import { Box, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

import type { DimensionField } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  field: DimensionField;
}

const TextField = ({ field, children }: PropsWithChildren<Props>) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        borderBottom: "1px dashed",
        borderBottomColor: "divider",
      }}
    >
      <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
        {field.config.customLabel || field.meta.caption}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          p: ".7rem 1rem",
          gap: ".3rem",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default TextField;
